import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowParticularVehicle from "../../components/vehicles/showParticularVehicle";

export default function ParticularVehicleView () {
    return (
        <>
            <Layout children={ShowParticularVehicle()} sectionTitle="Detalles del vehículo"/>
        </>
    )
}